<template>
<v-card class="pb-4 box-shadow-custom">
    <v-snackbar v-model="snackbar" :timeout="2000" top right color="primary">
        Copied
        <v-btn text @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="600px">
        <v-card>
            <v-icon class="close-btn" @click="dialog = false">mdi-close</v-icon>
            <v-card-title>
                <span class="headline">Share with others</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-clipboard:copy="shareLink" v-clipboard:success="onCopy" v-clipboard:error="onError" :value="shareLink" label="Copy link" append-icon="mdi-content-copy" dense outlined></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-card class="pa-1" flat>
        <v-data-table @click:row="clicked" :footer-props="{ itemsPerPageOptions:[10, 20, 50, 100]}" :options.sync="options" :server-items-length="totalDesserts" :loading="loading" loading-text="Loading... Please wait" :headers="header" :items="desserts" item-key="id" :expanded="expanded" class="elevation-0">
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title class="font-weight-medium headline primary--text">Test History</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer />
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark v-bind="attrs" v-on="on" class="mr-4">
                                <v-icon small left>mdi-swap-vertical-bold</v-icon>Export<v-icon small right>mdi-chevron-down-circle</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item v-for="(item, index) in items" :disabled="disableExportBtn" :key="index" @click="callToAction(item.action)">
                                <v-list-item-title ms>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <div>
                                                <span>{{ item.title }}</span>
                                                <span v-if="item.action == 'exportAll'" class="float-right">
                                                    <v-icon color="primary" dark v-bind="attrs" v-on="on" small>mdi-help-circle-outline</v-icon>
                                                </span>
                                            </div>
                                        </template>
                                        <span>Max 300,000 records can be exported at once.</span>
                                    </v-tooltip>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                        <template v-slot:activator="{ on }">
                            <span v-on="on">
                                <v-combobox v-model="computedDateFormattedMomentjs" :value="date" multiple label="Select Date" append-icon="mdi-calendar" hide-details outlined dense></v-combobox>
                            </span>
                        </template>
                        <v-date-picker v-model="date" color="primary" range>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                            <v-btn text color="primary" :disabled="date.length != 2 || date[0] > date[1]" @click="onDate(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.test_url="{ item }">
                <div class="pa-2" style="width: 400px;white-space: ;">
                    <v-icon class="mr-2" small>mdi-open-in-new</v-icon><a :href="item.test_url" target="_block">{{item.test_url}}</a>
                </div>
            </template>
            <template v-slot:item.hops="{ item }">
                <v-chip class="white" label small color="primary" dark>
                    {{item.hops}}
                </v-chip>
            </template>
            <template v-slot:item.os="{ item }">
                <v-icon v-if="item.platform == 'android_phone'" class="mx-2 green--text text--darken-2">mdi-android</v-icon>
                <v-icon v-if="item.platform == 'android_tablet'" class="mx-2 green--text text--darken-2">mdi-tablet</v-icon>
                <v-icon v-else-if="item.platform == 'windows_desktop'" class="mx-2 light-blue--text text--darken-2">mdi-microsoft-windows</v-icon>
                <v-icon v-else-if="item.platform == 'ios_iphone'" class="mx-2 grey--text text--darken-2">mdi-apple</v-icon>
                <v-icon v-else-if="item.platform == 'ios_ipad'" class="mx-2 grey--text text--darken-2">mdi-tablet-ipad</v-icon>
            </template>
            <template v-slot:item.os_var="{ item }">
                {{item.os_ver}}
            </template>
            <template v-slot:item.country="{ item }">
                <v-chip class="grey lighten-4" label small>
                    <span :class="`flag-icon flag-icon-${item.country.toLowerCase()} mr-2`"></span>
                    {{item.country}}
                </v-chip>
            </template>
            <template v-slot:item.createdAt="{ item }">
                {{dateTime(item.test_time)}}
            </template>
            <template v-slot:item.time="{ item }">
                ~ {{Math.round(item.time_ms / 1000)}} sec
            </template>
            <template v-slot:item.action="{ item }">
                <div class="d-flex justify-center align-center">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn icon class="mr-2" color="primary" @click="share(item.id)" :loading="loading" v-on="on">
                                <v-icon>mdi-share-variant</v-icon>
                            </v-btn>
                        </template>
                        <span>Share</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn icon color="primary" text v-on="on" :to="{ name: 'OfferTest', query: { url: item.test_url, device: item.platform, country: item.country, version: item.os_ver } }">
                                <v-icon>mdi-flash</v-icon>
                            </v-btn>
                        </template>
                        <span>Test Offer</span>
                    </v-tooltip>
                </div>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="white">
                    <v-data-table :headers="subHeader" hide-default-footer :items="item.redirects" class="elevation-0 mb-4">
                        <template v-slot:item.url="{ item }">
                            <div style="width: 200px;white-space: break-spaces;">
                                <v-icon small>mdi-open-in-new</v-icon> <a :href="item.url" target="_block">{{item.url}}</a>
                            </div>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-chip small :color="item.status <= 300 ? 'green' : item.status <= 400 ? 'blue' : item.status <= 500 ? 'orange' : item.status <= 600 ? 'red': ''" label text-color="white">
                                <v-icon size="15" v-text="item.status <= 300 ? 'mdi-checkbox-marked-circle-outline' : item.status <= 400 ? 'mdi-skip-forward-outline' : item.status <= 500 ? 'mdi-window-close' : item.status <= 600 ? 'mdi-alert-circle-outline': ''" left></v-icon>
                                {{ item.status }}
                            </v-chip>
                        </template>
                        <template v-slot:item.time="{ item }">
                            <v-chip class="pa-2 pr-3" small color="indigo" text-color="white">
                                <v-avatar left>
                                    <v-icon>mdi-clock</v-icon>
                                </v-avatar>
                                {{Math.round((item.time / 1000) * 10)/10}} sec
                            </v-chip>
                        </template>
                    </v-data-table>
                </td>
            </template>
        </v-data-table>
    </v-card>
    <div class="filter-opener" @click="historyFilterModel = true">
        <v-icon class="filter-icon">mdi-filter-outline</v-icon>
    </div>
    <v-dialog v-model="historyFilterModel" max-width="500px" content-class="modal-right">
        <v-card class="cus-card">
            <v-card-title>
                <span class="headline">Filter</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" style="margin-bottom: -35px">
                        <label for="countries">Country</label>
                        <v-combobox id="countries" v-model="search.countries" :items="countryWithCode" item-text="Country Name" item-value="Country" dense multiple small-chips outlined></v-combobox>
                    </v-col>
                    <v-col cols="12" style="margin-bottom: -35px">
                        <label for="devices">Device</label>
                        <v-combobox id="devices" v-model="search.devices" :items="devices" item-text="text" item-value="value" dense multiple small-chips outlined></v-combobox>
                    </v-col>
                    <v-col cols="12" style="margin-bottom: -35px">
                        <label for="osVersion">Os Version</label>
                        <v-combobox id="osVersion" v-model="search.os" :items="osVer" dense multiple small-chips outlined></v-combobox>
                    </v-col>
                    <v-col cols="6" style="margin-bottom: -35px">
                        <label for="">Min Number of Hops</label>
                        <v-text-field type="number" v-model="search.hops.left" class="ma-0 mt-3 border-radius" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="6" style="margin-bottom: -35px">
                        <label for="">Max Number of Hops</label>
                        <v-text-field type="number" v-model="search.hops.right" class="ma-0 mt-3 border-radius" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" style="margin-bottom: -35px">
                        <label for="">URL</label>
                        <v-text-field type="text" v-model="search.url" class="ma-0 mt-3 border-radius" dense outlined></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="pa-4">
                <v-btn color="primary" class="text-capitalize px-6" @click="getResponse">Search</v-btn>
                <v-btn color="grey" class="text-capitalize" outlined @click="historyFilterModel = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-card>
</template>

<script>
import Papa from 'papaparse'
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
import moment from 'moment'
import {
    mapActions,
    mapMutations,
    mapGetters
} from 'vuex'
const config = require('../../config.json')[process.env.NODE_ENV]
export default {
    data: () => ({
        date: [moment(new Date()).subtract(30, 'days').format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")],
        lastDate: [],
        modal: false,
        hostname: config.frontend_url,
        totalDesserts: 0,
        desserts: [],
        loading: true,
        historyFilterModel: false,
        options: {
            page: 1,
            itemsPerPage: 100
        },
        search: {
            countries: [],
            os: [],
            devices: [],
            hops: {
                left: "",
                right: ""
            },
            url: ""
        },
        osVer: [
            '4.0',
            '5.0',
            '6.0',
            '7.0',
            '8.0',
            '9.0',
            '10.0',
            '11.0',
            '12.0',
            '13.0',
            '14.0',
            '15.0',
        ],
        menu1: false,
        menu2: false,
        expanded: [],
        singleExpand: false,
        editedIndex: -1,
        dialog: false,
        editedItem: {},
        snackbar: false,
        shareLink: '',
        count: 1,
        header: [{
                text: 'Link',
                align: 'left',
                sortable: false,
                value: 'test_url',
            },
            {
                text: 'Country',
                align: 'center',
                sortable: false,
                value: 'country'
            },
            {
                text: 'Device',
                align: 'center',
                sortable: false,
                value: 'os'
            },
            {
                text: 'Os Version',
                align: 'center',
                sortable: false,
                value: 'os_var'
            },
            {
                text: 'Hops',
                align: 'center',
                sortable: false,
                value: 'hops'
            },
            {
                text: 'Created At',
                align: 'center',
                value: 'createdAt'
            },
            {
                text: 'Time',
                align: 'center',
                value: 'time'
            },
            {
                text: 'Action',
                align: 'center',
                sortable: false,
                value: 'action'
            },
            {
                text: '',
                value: 'data-table-expand'
            },
        ],
        subHeader: [{
                text: 'URL',
                align: 'left',
                sortable: false,
                value: 'url',
            },
            {
                text: 'Status',
                align: 'left',
                sortable: false,
                value: 'status',
            },
            {
                text: 'Times',
                align: 'left',
                sortable: false,
                value: 'time',
            }
        ],
        items: [
            { title: 'Export', action: "export" },
            { title: 'Export All', action: "exportAll" }
        ],
        disableExportBtn: false
    }),
    computed: {
        ...mapGetters(['countryWithCode', 'devices']),
        dateRangeText() {
            return this.date.join(' ~ ')
        },
        computedDateFormattedMomentjs() {
            return this.date.map(res => {
                return this.date ? moment(res).format('YYYY/MM/DD') : ''
            })
        }
    },
    watch: {
        options: {
            async handler() {
                await this.getResponse()
            },
            deep: true,
        },
    },
    async mounted() {
        await this.getResponse()
        // await this.GetResponse()
    },
    methods: {
        ...mapActions(['GetResponse', 'PostResponse', 'TrackEvents']),
        ...mapMutations(['SnackbarSuccess']),
        onCopy(e) {
            let dataMsg = { success: true, message: 'Copy Successfully', action: 'success' }
            this.SnackbarSuccess(dataMsg)
        },
        onError(e) {
            let dataMsg = { success: true, message: 'Copy ' + e.text, action: 'error' }
            this.SnackbarSuccess(dataMsg)
        },
        callToAction(name) {
            if (name == 'export') {
                this.downloadCSV();
            } else if (name == 'exportAll') {
                this.exportAllCSVData();
            }
        },
        async share(_id) {
            this.loading = true
            try {
                let url = `/internal/v2/share/${_id}`
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.shareLink = data.data.link
                    this.loading = false
                    this.dialog = true
                    let dataMsg = { success: true, message: data.message, action: 'success' }
                    this.SnackbarSuccess(dataMsg)
                    this.TrackEvents({ event_name: 'test_history', action: "share" })
                } else {
                    this.loading = false
                    let dataMsg = { success: true, message: data.message, action: 'success' }
                    this.SnackbarSuccess(dataMsg)
                }
            } catch (err) {
                this.loading = false
                let dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
                this.SnackbarSuccess(dataMsg)
            }
        },
        async getResponse() {
            try {
                const data = await this.getDataFromApi(this.date)
                // search
                this.desserts = data.items
                this.totalDesserts = data.count
                this.historyFilterModel = false;
            } catch (err) {
                console.log(err)
            }
        },
        downloadCSV() {
            var csvArray = []
            this.desserts.map(res => {
                let itemObject = { auto_test_id: res.auto_test_id, city: res.city, country: res.country, final_url: res.final_url, hops: res.hops, integration_id: res.integration_id, isp: res.isp, offer_id: res.offer_id, os_ver: res.os_ver, platform: res.platform, redirects: JSON.stringify(res.redirects), test_time: res.test_time, test_url: res.test_url, time_ms: res.time_ms, total_ms: res.total_ms }
                csvArray.push(itemObject)
            })
            var csv = Papa.unparse(csvArray);
            var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            var csvURL = null;
            csvURL = window.URL.createObjectURL(csvData);
            var tempLink = document.createElement('a');
            tempLink.href = csvURL;
            tempLink.setAttribute('download', 'history.csv');
            tempLink.click();
            this.TrackEvents({event_name: "export_file", file_id: "history.csv" });
            this.TrackEvents({event_name: "test_history", action: "export" });
        },
        async exportAllCSVData() {
            this.disableExportBtn = true;
            let value = {
                url: '/internal/v2/link-history',
                data: {
                    'start': this.date[0],
                    'end': this.date[1]
                }
            };
            let response = (await this.PostResponse(value)).data;
            let dataMsg = {};
            if (response.success) {
                dataMsg = { success: true, message: "Test History export has been scheduled successfully.", action: 'success' };
                setTimeout(() => this.$router.push('/export-history?recentExport=true'), 1500);
            } else {
                dataMsg = { success: true, message: "Something Went Wrong. Please Try Again Later!", action: 'error' };
            }
            this.SnackbarSuccess(dataMsg)
            this.disableExportBtn = false;
        },
        clicked(value) {
            if (this.count === 1) {
                this.expanded.push(value)
                this.count = 2
            } else {
                this.expanded = []
                this.count = 1
            }
        },
        parseUrl(Obj = {}) {
            let arrayUrl = [];
            let trimSearchObject = Object.keys(Obj).reduce((acc, curr) => {
                if (Obj[curr]) {
                    if (typeof Obj[curr] === 'string' || typeof Obj[curr] === 'number' || typeof Obj[curr] === 'boolean') {
                        if (typeof Obj[curr] === 'string') {
                            acc[curr] = Obj[curr].trim();
                        } else {
                            acc[curr] = Obj[curr]
                        }
                    } else {
                        let myArrayQry = Obj[curr].map(function (el) {
                            return curr + '[]=' + el;
                        }).join('&');
                        if (myArrayQry) {
                            arrayUrl.push(myArrayQry)
                        }
                    }
                }
                return acc;
            }, {});

            let finalArrayUrl = arrayUrl.join('&')
            let convertUrl = new URLSearchParams(trimSearchObject).toString();
            if (convertUrl) {
                convertUrl = convertUrl + '&';
            }
            let finalUrl = `${convertUrl} ${finalArrayUrl ? `${finalArrayUrl}` : ''}`
            finalUrl = finalUrl.replace(/\s+/g, '');
            return finalUrl
        },
        getDataFromApi(data) {
            this.loading = true
            return new Promise(async (resolve) => {
                if (this.date != this.lastDate) {
                    this.options.page = 1;
                    this.lastDate = this.date;
                }
                const {
                    page,
                    itemsPerPage
                } = this.options

                let item = null
                let tableDara = {
                    data,
                    page,
                    itemsPerPage
                }
                let selectedCountries = this.search.countries.map(a => a.Country);
                let selectedDevices = this.search.devices.map(a => a.value);
                let serachData = { countries: selectedCountries, devices: selectedDevices, os: this.search.os, url: this.search.url }
                let parseSearchDataToString = this.parseUrl(serachData);
                let queryURL = itemsPerPage > -1 ? '?page=' + page + '&limit=' + itemsPerPage + '&start=' + this.date[0] + '&end=' + this.date[1] : '';
                queryURL += `&${parseSearchDataToString}`
                let hops = Object.assign({}, this.search.hops);          
                if (!(this.search.hops.left == '' && this.search.hops.right == '')) {
                    if (this.search.hops.left == '') hops.left = hops.right;
                    else hops.right = hops.left;
                }
                queryURL += `&hops=${encodeURIComponent(JSON.stringify(hops))}`
                try {
                    let url = `/internal/v2/link-history${queryURL}`
                    item = (await this.GetResponse(url)).data

                } catch (err) {
                    console.log(err)
                    item = []
                }
                let items = item.data.history
                const total = item.data.total
                const count =  item.data.count
                this.loading = false
                resolve({
                    items,
                    total,
                    count
                })
            })
        },
        dateTime(date) {
            return moment(date).format('MMMM Do YYYY h:mm a');
        },
        async onDate(date) {
            this.$refs.dialog.save(date)
            await this.getResponse()
        },
        editItem(item) {
            this.dialog = true
            this.editedIndex = this.desserts.indexOf(item.id)
            this.editedItem = Object.assign({}, item)
        },
    }
}
</script>

<style scoped>
.filter-opener {
    background: #138fc1;
    border-radius: 9px;
    z-index: 1;
    width: 61px;
    height: 51px;
    position: fixed;
    top: 15em;
    right: -12px;
    cursor: pointer;
}

.filter-icon {
    color: white;
    font-size: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: inherit;
}
</style>
